import HistoryIconLink from "../../components/change-history/HistoryIconLink";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import Table, { Row } from "../../components/ui/table";
import { IMcpTool } from "../../interfaces/endpoints/IMcpTool";

interface McpToolsTableProps {
  tools: IMcpTool[];
  onToggle: (tool: IMcpTool) => void;
  onEdit: (tool: IMcpTool) => void;
}

const columns = [
  "Tool Name",
  "Category",
  "Method",
  "Endpoint",
  "Enabled",
  "", "Actions"
];

const getMethodStyle = (method: string) => {
  if (method === "GET") return "bg-green-100 text-green-800";
  if (method === "POST") return "bg-blue-100 text-blue-800";
  return "bg-yellow-100 text-yellow-800";
};

const McpToolsTable: React.FC<McpToolsTableProps> = ({
  tools,
  onToggle,
  onEdit
}) => (
  <Table titles={columns} style="hover">
    {tools.map((tool) => (
      <Row
        key={tool.id}
        toolName={
          <div>
            <span className="font-medium">{tool.toolName}</span>
            <p className="text-xs text-gray-500 max-w-xs truncate">
              {tool.description.substring(0, 80)}
              {tool.description.length > 80 ? "..." : ""}
            </p>
          </div>
        }
        category={
          <span className="px-2 py-1 bg-gray-100 rounded text-xs">
            {tool.category}
          </span>
        }
        method={
          <span className={`px-2 py-1 rounded text-xs font-medium ${getMethodStyle(tool.httpMethod)}`}>
            {tool.httpMethod}
          </span>
        }
        endpoint={
          <span className="text-xs font-mono">{tool.endpoint}</span>
        }
        enabled={
          <button
            onClick={() => onToggle(tool)}
            className={`relative inline-flex h-6 w-11 rounded-full ${
              tool.isEnabled ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 mt-1 rounded-full bg-white ${
                tool.isEnabled ? "translate-x-6" : "translate-x-1"
              }`}
            />
          </button>
        }
        history={<HistoryIconLink entityName="McpTool" entityId={tool.id} />}
        actions={
          <button
            onClick={() => onEdit(tool)}
            className="p-1 hover:bg-gray-100 rounded"
          >
            <PencilSquareIcon className="w-5 h-5 text-gray-600" />
          </button>
        }
      />
    ))}
  </Table>
);

export default McpToolsTable;
